import Media from '~/models/Media'
import { BaseMemoryCache } from '../baseMemoryCache'

export class MediaCache extends BaseMemoryCache<Media> {
	private localUrls = new Map<string, string>()

	setMedias(medias: Media[], files: File[]): void {
		const filesByName = new Map(files.map((file) => [file.name, file]))
		medias.forEach((media) => {
			const file = filesByName.get(media.name)
			if (!media.id || !file) return
			this.localUrls.set(media.id, URL.createObjectURL(file))
		})
	}

	getLocalUrl(mediaId: string): string | undefined {
		return this.localUrls.get(mediaId)
	}

	override clear(): void {
		this.localUrls.forEach((url) => URL.revokeObjectURL(url))
		this.localUrls.clear()
		super.clear()
	}
}

export const mediaCache = new MediaCache()
